module.exports = __webpack_public_path__ + "static/media/modelagem-de-baloes@2x.d5613052.jpg";